import { render, staticRenderFns } from "./step_datos_hipoteca_2avivienda.vue?vue&type=template&id=3b7b6a6b&scoped=true"
import script from "./step_datos_hipoteca_2avivienda.vue?vue&type=script&lang=js"
export * from "./step_datos_hipoteca_2avivienda.vue?vue&type=script&lang=js"
import style0 from "./step_datos_hipoteca_2avivienda.vue?vue&type=style&index=0&id=3b7b6a6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7b6a6b",
  null
  
)

export default component.exports